import currency from 'currency.js'
import Model, { ID, Integer, MODEL_LEVEL } from 'src/models/model'
import Site from 'src/models/site/Site'

export default class Tax extends Model {
  static name = 'Tax'

  static isConfiguration = true

  static versioned = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Circuit]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      name: {
        type: String,
        required: true
      },
      percentThousandths: {
        type: Integer,
        default: 0
      },
      sites: {
        type: [Site],
        default: () => { return [] },
        encode (data) {
          data.siteIds = _.map(this.sites.data, 'id')
        },
        reference: true
      }
    }
  }

  get percent () {
    return this.percentThousandths / 1000
  }

  taxFromGross (gross, totalTaxPercentThousandths = null) {
    totalTaxPercentThousandths ||= this.percentThousandths
    // return Math.round(gross * this.percentThousandths / (100000 + totalTaxPercentThousandths) * 100) / 100
    return currency(gross).multiply(this.percentThousandths).divide(100000 + totalTaxPercentThousandths).value
  }

  taxFromNet (net) {
    // We need to use absolute value here, as javascript will round towards zero for negative numbers
    // Ruby will round towards negative infinity for negative numbers
    const isNegative = net < 0

    const value = currency(Math.abs(net)).multiply(this.percentThousandths).divide(100000).value

    return isNegative ? -value : value
  }
}
